import gql from 'graphql-tag'

export default gql`
	mutation ($_id: MongoID!) {
		removeListzoom(_id: $_id) {
			recordId
		}
	}
`
